import { createTranslations } from '@npco/common-utils-translations'

export const transferErrorPopperTranslations = createTranslations({
  title: 'Something went wrong',
  description:
    'We were having issues loading your details. Please make sure you’re connected to the internet and try again.',
  actionButton: 'Try Again',
})
